import { useQueryClient } from "@tanstack/react-query";

import { getGetInsightsQueryKey } from "@vega-api/generated/insights/insights";
import { NotificationContentType } from "@vega-api/generated/types/notificationContentType";
import { useNotificationEvent } from "@vega-modules/scenes/Notifications/useNotificationEvent";

const [INSIGHTS_KEY_PREFIX] = getGetInsightsQueryKey();

export const useInsightsLiveRefresh = () => {
  const queryClient = useQueryClient();

  useNotificationEvent(
    NotificationContentType.COINVEST_EVENT_DEAL_INSIGHT_UPDATED,
    () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith(INSIGHTS_KEY_PREFIX),
      });
    },
  );
};
